import axios from "axios";
import Config from "../config";
import RefreshTokenHandler from "../refreshToken/refreshToken";

export const getDrScheduleByDoctorIdAndDateRange = async (
  email,
  clinic_code,
  doctor_id,
  start_date,
  end_date
) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/dr-schedule/by-doctor-id-date-range?email=${email}&clinic_code=${clinic_code}&doctor_id=${doctor_id}&start_date=${start_date}&end_date=${end_date}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDrScheduleByDoctorIdAndDateRange(
          email,
          clinic_code,
          doctor_id,
          start_date,
          end_date
        );
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

export const updateDrSchedule = async (
  email,
  schedule_id,
  company_code,
  distributor_code,
  clinic_code,
  patient_id,
  doctor_id,
  date,
  start_time,
  end_time,
  start_time_clock,
  end_time_clock,
  current_status,
  active,
  doctor_comment,
  patient_comment,
  availability,
  category,
  service_type
) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/dr-schedule/${schedule_id}`;
    const result = await axios.put(
      url,
      {
        email,
        schedule_id,
        company_code,
        distributor_code,
        clinic_code,
        patient_id,
        doctor_id,
        date,
        start_time,
        end_time,
        start_time_clock,
        end_time_clock,
        current_status,
        active,
        doctor_comment,
        patient_comment,
        availability,
        category,
        service_type,
      },
      {
        headers: {
          Authorization: token || "",
        },
      }
    );
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateDrSchedule(
          email,
          schedule_id,
          company_code,
          distributor_code,
          clinic_code,
          patient_id,
          doctor_id,
          date,
          start_time,
          end_time,
          start_time_clock,
          end_time_clock,
          current_status,
          active,
          doctor_comment,
          patient_comment,
          availability,
          category,
          service_type
        );
      } else {
        return err.response;
      }
    } else {
      return err.response;
    }
  }
};

export const getDrScheduleByPatientIdAndDateRange = async (
  email,
  patient_id,
  start_date,
  end_date
) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/dr-schedule/by-patient-id-date-range?email=${email}&patient_id=${patient_id}&start_date=${start_date}&end_date=${end_date}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDrScheduleByPatientIdAndDateRange(
          email,
          patient_id,
          start_date,
          end_date
        );
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

export const getScheduleById = async (email, schedule_id) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/dr-schedule/by-schedule-id?email=${email}&schedule_id=${schedule_id}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getScheduleById(email, schedule_id);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

export const getLatestScheduleByPatientId = async (email, patient_id) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/dr-schedule/latest-by-patient-id?email=${email}&patient_id=${patient_id}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getLatestScheduleByPatientId(email, patient_id);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};
